import { RouteButton } from "@/components/Buttons";
import { openFolder } from "@/components/misc";
import { CiEdit } from "react-icons/ci";
import { FaRegClipboard, FaRegEnvelopeOpen, FaTasks, FaUpload } from "react-icons/fa";

export function UpdateProjectButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/projects/update_project/" + project_id} text="Edit" icon={<CiEdit />} />
    )
}

export function AssignTasksButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/tasks/assign_tasks/" + project_id} text="Assign Tasks" icon={<FaTasks />} />
    )
}

export function CreateSubmittalButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/submittals/create_submittal_from_project/" + project_id} text="Create Submittal" icon={<FaRegClipboard />} />
    )
}

export function CreateRFIButton({project_id}: {project_id: string}) {
    return (
        <RouteButton route={"/rfi/create_rfi_from_project/" + project_id} text="Create RFI" icon={<FaRegEnvelopeOpen />} />
    )
}

export function UploadFileButton({project_id, folder_location}: {project_id: string, folder_location: string}) {
    return (
        <RouteButton route={"/projects/upload_file/" + project_id} text="Upload File" onClick={() => openFolder((folder_location ?? "") + "/documents")} icon={<FaUpload />} />
    )
}

export function UpdateBidButton({bid_id}: {bid_id: string}) {
    return (
        <RouteButton route={"/bids/update_bid/" + bid_id} text="Edit" icon={<CiEdit />} />
    )
}